import React from 'react';
import { getTherapistName } from './utils';

function CartSummaryStep({ selectedCenter, serviceCart, getTherapistPrice, getCartTotal, onRemoveCartItem, onAddMoreServices, guestCount, currentGuestIndex }) {
  const isGroup = guestCount > 1;
  const guestLabel = isGroup ? `Guest ${currentGuestIndex + 1}` : null;

  return (
    <div className="step-content">
      <h1 className="step-title">{isGroup ? `SERVICES FOR ${guestLabel.toUpperCase()}` : 'YOUR SERVICES'}</h1>
      <p className="step-subtitle">{selectedCenter?.name}</p>

      <div className="cart-summary">
        {serviceCart.map((item, idx) => (
          <div key={idx} className="cart-item">
            <div className="cart-item-info">
              <h4>{item.service.name}</h4>
              <p className="cart-item-therapist">
                with {(item.therapist?.Id || item.therapist?.id) === 'any' ? 'Any provider' : getTherapistName(item.therapist)}
              </p>
              {item.optionalAddOns?.map(a => (
                <p key={a.id} className="cart-item-addon">+ {a.name} {a.price > 0 ? `· $${a.price}` : ''}</p>
              ))}
              {item.mandatoryAddOns?.map(a => (
                <p key={a.id} className="cart-item-addon">+ {a.name} {a.price > 0 ? `· $${a.price}` : ''}</p>
              ))}
            </div>
            <div className="cart-item-right">
              <span className="cart-item-price">${getTherapistPrice(item.service, item.therapist).toFixed(2)}</span>
              <button className="cart-item-remove" onClick={() => onRemoveCartItem(idx)}>✕</button>
            </div>
          </div>
        ))}

        <div className="cart-total">
          <span>Total</span>
          <span>${getCartTotal()}</span>
        </div>

        <button className="cart-add-more" onClick={onAddMoreServices}>
          + Add More Services{isGroup ? ` for ${guestLabel}` : ''}
        </button>
      </div>
    </div>
  );
}

export default CartSummaryStep;
